import HasLocalValue from '@/Mixins/HasLocalValue'

export default {
  mixins: [HasLocalValue],

  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Array],
      default: '',
    },
    helper: {
      type: String,
      default: '',
    },
  },
}
